var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustryInitial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.7485C15.5 14.5135 14.88 15.1335 14.115 15.1335C13.351 15.1335 12.73 14.5135 12.73 13.7485V10.5185C12.73 9.75352 13.351 9.13352 14.115 9.13352C14.88 9.13352 15.5 9.75352 15.5 10.5185V13.7485ZM10.885 13.7485C10.885 14.5135 10.265 15.1335 9.5 15.1335C8.735 15.1335 8.115 14.5135 8.115 13.7485V10.5185C8.115 9.75352 8.735 9.13352 9.5 9.13352C10.265 9.13352 10.885 9.75352 10.885 10.5185V13.7485ZM6.27 13.7485C6.27 14.5135 5.649 15.1335 4.885 15.1335C4.12 15.1335 3.5 14.5135 3.5 13.7485V10.5185C3.5 9.75352 4.12 9.13352 4.885 9.13352C5.649 9.13352 6.27 9.75352 6.27 10.5185V13.7485ZM9.5 4.13352V1.00152C9.5 0.203518 8.609 -0.273483 7.945 0.169517L1.391 3.53952C0.834 3.91052 0.5 4.53552 0.5 5.20352V16.1335C0.5 17.2375 1.396 18.1335 2.5 18.1335H16.5C17.604 18.1335 18.5 17.2375 18.5 16.1335V1.00152C18.5 0.203518 17.609 -0.273483 16.945 0.169517L9.5 4.13352Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryInitial);
export default __webpack_public_path__ + "static/media/industry_initial.7e6b650f.svg";
export { ForwardRef as ReactComponent };